import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumb = ({ items = [] }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Build breadcrumb automatically from URL if no items provided
  const getBreadcrumbFromUrl = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbItems = [];
    
    if (pathSegments.length > 0) {
      // Add category
      const category = pathSegments[0];
      const categoryNames = {
        'office365': 'Office 365',
        'google-workspace': 'Google Workspace', 
        'security': 'Sécurité',
        'mobile': 'Mobile',
        'synology': 'Synology',
        'intelligence-artificielle': 'Intelligence Artificielle'
      };
      
      breadcrumbItems.push({
        label: categoryNames[category] || category,
        url: `/${category}`
      });
      
      // Add sub-page if present
      if (pathSegments.length > 2) {
        const type = pathSegments[1]; // 'guides', 'articles', 'procedures'
        const id = pathSegments[2];
        
        breadcrumbItems.push({
          label: items.length > 1 ? items[1].label : id,
          url: location.pathname,
          isLast: true
        });
      }
    }
    
    return breadcrumbItems;
  };
  
  const displayItems = items.length > 0 ? items : getBreadcrumbFromUrl();
  
  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-6 bg-white bg-opacity-60 backdrop-blur-sm px-4 py-3 rounded-xl shadow-sm">
      <Link
        to="/"
        className="flex items-center text-gray-600 hover:text-indigo-600 transition-colors duration-200"
      >
        <Home className="h-4 w-4 mr-1" />
        Accueil
      </Link>
      
      {displayItems.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRight className="h-4 w-4 text-gray-400" />
          {item.isLast || index === displayItems.length - 1 ? (
            <span className="text-gray-900 font-medium">{item.label}</span>
          ) : (
            <Link
              to={item.url || `/${item.id}`}
              className="text-gray-600 hover:text-indigo-600 transition-colors duration-200"
              onClick={(e) => {
                // Special handling for guide parent navigation
                if (index === displayItems.length - 2) {
                  // This is the parent guide link (level 3 in 4-level breadcrumb)
                  e.preventDefault();
                  const pathSegments = location.pathname.split('/').filter(Boolean);
                  if (pathSegments.length >= 3 && pathSegments[1] === 'guides') {
                    const category = pathSegments[0];
                    const guideId = item.id;
                    // Navigate to the parent guide
                    navigate(`/${category}/guides/${guideId}`);
                  }
                } else if (item.id && item.id.includes('-') && !item.url) {
                  e.preventDefault();
                  const pathSegments = location.pathname.split('/').filter(Boolean);
                  if (pathSegments.length >= 3) {
                    const category = pathSegments[0];
                    const guideId = item.id;
                    navigate(`/${category}/guides/${guideId}`);
                  }
                }
              }}
            >
              {item.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;